import { render, staticRenderFns } from "./tokyoHouse.vue?vue&type=template&id=65ba350e&scoped=true&"
import script from "./tokyoHouse.vue?vue&type=script&lang=js&"
export * from "./tokyoHouse.vue?vue&type=script&lang=js&"
import style0 from "./tokyoHouse.vue?vue&type=style&index=0&id=65ba350e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ba350e",
  null
  
)

export default component.exports